module.exports = __webpack_public_path__ + "static/aboutBackground-148f2e5d76665b3e121922a72c05dc0d.jpg";